import { Pill } from './Pill';
import { runnerStageChip } from '../lib/runnerChips';

export function RunnerStageChip({ status }: { status: string }) {
  const c = runnerStageChip(status);
  return <Pill label={c.label} fg={c.fg} bg={c.bg} strong={status === 'live'} />;
}
